import { Grid, Box, Link } from "@mui/material";
import React, { useState, useEffect } from "react";
import Web3 from "web3";
import DashboardCard from "../../Components/DashboardCard";

import DashboardMenuForDesktop from "../../Components/DashboardMenu";
import together from "../../images/together.png"
import logo from "../../images/icon.png"
import DashboardTogetherCard from "../../Components/DasboardTogetherCards";
import LPToken from "../../Components/Bonds/LPtoken"
import NtError from "../../Components/ErroBook/ntErro";

var web3;
var deciConvert = 1e9;
var osAdd;
var osAbi;
var osContract

const Together = () => {

    const [useDefaultAccount, setDefaultAccount] = useState();
    const [useUserBalance, setUserBalance] = useState('0');
    const [usebuttonText, setbuttonText] = useState('Connect Wallet');
    const [useTreasuryBalance, setTreasuryBalance] = useState('0');
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    const [useTS, setTS] = useState('0');
    const [useMC, setMC] = useState('0');
    const [useCS, setCS] = useState('0');
    const [useTokenPrice, setTokenPrice] = useState('0');
    const [useTokenBalance, setTokenBalance] = useState('0');


    useEffect(()=> {
        connectWallet();
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[useError]);

    /***************************************************
    *
    *    Slicing function
    *
    ****************************************************/
     const conciseWallet = (value) => {
        const intvalue = value.toString();
        if( intvalue != ""){
            const start_char = value.toString().substring(0,4)+".....";
            const end_char = value.toString().substr(value.length - 3);
            setbuttonText("Connected " + start_char + end_char)
        }else{
            setErrorType('walletNotConnected')
            setError(true)
            setbuttonText("Connect Wallet")
        }
    }

    /***************************************************
    *
    *    Numaric amount function
    *
    ****************************************************/
    const numaricAmount = (value) => {
        // return value.toLocaleString();
        return value.toLocaleString(undefined, {maximumFractionDigits:2})
    }
    
    /***************************************************
    *
    *    update account, will cause component re-render
    *
    ****************************************************/
	const accountChangedHandler = (newAccount) => {
		setDefaultAccount(newAccount);
        conciseWallet(newAccount);
	}
    
    // Change network handling 
    try {
        window.ethereum.on('chainChanged', (_chainId => {
            if ( _chainId == "0x38") {
                console.log('you are on BSC', _chainId)
                window.location.reload();
            }else if ( _chainId == "0x61") {
                console.log('you are on BSC Test Net', _chainId)
                window.location.reload();
            }else{
                console.log('Wrong network Connected', _chainId)
                setErrorType('wrongNetwork')
                setError(true)
            }
        }));
    } catch (error) {
        console.log('Updated Address error ', error)
    }

    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            accountChangedHandler(_mAddress.toString())
            setErrorType('walletChanged')
            setError(true)
            console.log('Updated Address ', _mAddress)
        }));
       
    } catch (error) {
        console.log('Updated Address error ', error)
    }
    /*******
    *
    *    Connecting Metamask
    *    Creating Contract object
    *    Save Wallet address in varibale
    *
    ******/
    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){
            web3 = new Web3(window.ethereum);
           
            //OhmniShiba contract 
            osAdd = "0xf22e419A6827ed431c97A778b35A719447BB2c86";
            osAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"previousTWAPEpochPeriod","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newTWAPEpochPeriod","type":"uint256"}],"name":"TWAPEpochChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousTWAPOracle","type":"address"},{"indexed":true,"internalType":"address","name":"newTWAPOracle","type":"address"}],"name":"TWAPOracleChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newTWAPSource","type":"address"}],"name":"TWAPSourceAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"removedTWAPSource","type":"address"}],"name":"TWAPSourceRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"_burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newTWAPSourceDexPool_","type":"address"}],"name":"addTWAPSource","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newTWAPEpochPeriod_","type":"uint256"}],"name":"changeTWAPEpochPeriod","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newTWAPOracle_","type":"address"}],"name":"changeTWAPOracle","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"twapSourceToRemove_","type":"address"}],"name":"removeTWAPSource","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"vault_","type":"address"}],"name":"setVault","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"twapEpochPeriod","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"twapOracle","outputs":[{"internalType":"contract ITWAPOracle","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"vault","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
            osContract = new web3.eth.Contract( osAbi , osAdd );
            
            web3.eth.getBalance("0x2ABd66aF09F0bb648C6E010899De76aD6DeaF4D0").then(balance => {
                setTreasuryBalance(numaricAmount(balance))
            })
        .catch(error => {
            console.log(error.message);
        });
            //get connected wallet address
            try {
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    accountChangedHandler(_account.toString());
                    osContract.methods.balanceOf(_account.toString()).call().then( result => {
                        setTokenBalance(result/deciConvert)
                    })
                    .catch (error => {
                        console.log('user Balance', error)
                        setErrorType('maybeWrongNetwork')
                        setError(true)
                    })
                })
                .catch (error => {
                    console.log('user accountChangedHandler', error.code)

                    if(error.code == '4001'){
                        setErrorType('metamaskReject')
                        setError(true)
                    }else{
                        setErrorType('walletNotConnected')
                        setError(true)
                    }
                });
                
                fetch('https://api.coingecko.com/api/v3/coins/solana').then(result => {
                    result.json().then(data => {
                        let MPrice = data.market_data.current_price.usd;
                        let cSupply = data.market_data.circulating_supply;
                        let Tsupply = data.market_data.total_supply;
                        setTS(Tsupply)
                        setMC(MPrice*cSupply)
                        setCS(cSupply)
                        setTokenPrice(numaricAmount(MPrice))
                        console.log('total_supply ', Tsupply);
                    })
                });
            } catch (error) {
                console.log('Rejected.! ', error)
                setErrorType('noMetamask')
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }

    return(
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} className="position-relative">
                {useError ?
                    <NtError 
                        errorType = {useErrorType}
                    />
                :
                    <span />
                }
                <DashboardMenuForDesktop />
                <Grid md={2} />
                <Grid 
                    container
                    xs={12}
                    md={10} 
                    style={{backgroundColor: '#1D1D1D',minHeight:'100vh'}}
                    className="py-4 px-3 px-sm-5"
                >
                    <Grid
                        xs={12}
                        className="text-right pt-4 pb-5"
                    >
                        <Link href="#" onClick={connectWallet} className="Global---menu-nav-btn px-4 py-2 mx-1">
                            {usebuttonText}
                        </Link>
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center py-4"
                    >
                        <img src={together} className="img-fluid w-100" style={{maxWidth:400}} />
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="Dasboard-card-radius py-4 px-3 px-md-5"
                    >
                        <Grid
                            xs={12}
                            className="mb-4"
                        >
                            <h2>3, 3 Together</h2>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={6}
                            className="text-center py-4"
                        >
                            <h6>Treasury Balance</h6>
                            <h4>${useTreasuryBalance}</h4>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={6}
                            className="text-center py-4"
                        >
                            <h6>OHMS Price</h6>
                            <h4>${useTokenPrice}</h4>
                        </Grid>
                        <Grid
                            container
                            xs={12}
                            lg={8}
                            justifyContent="center"
                            alignContent="center"
                            className="mx-auto my-3"
                        >
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                
                            </Grid>
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                <h6 className="mb-0">Bond</h6>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                <h6 className="mb-0">Price</h6>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                <h6 className="mb-0">ROI (5-Day Rate)</h6>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                <h6 className="mb-0">Purchased</h6>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={2}
                                alignSelf="center"
                            >
                                
                            </Grid>
                        </Grid>
                        <LPToken />
                    </Grid>
                    
                    {/* <Grid
                        container
                        xs={12}
                        className="Dasboard-card-radius mt-5 py-4 px-3 px-md-5"
                    >
                        <Grid
                            xs={12}
                            className="mb-4"
                        >
                            <h2>Prize Pool Info</h2>
                        </Grid>
                        <Grid
                            container
                            xs={12}
                            md={8}
                            className="mx-auto"
                        >
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Winners / prize period</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">3</p>
                            </Grid>
                            
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Total Deposits</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">17,446.152 OHMS</p>
                            </Grid>
                            
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Total Sponsorship</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">330.142 OHMS</p>
                            </Grid>
                            
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Yield Source</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">OHMS</p>
                            </Grid>
                            
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Pool owner</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">OhmniShiba</p>
                            </Grid>
                            <Grid xs={12} style={{borderBottom: '1px solid #1D1D1D', margin: '5px 0'}} />
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Early Exit Fee</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">3%</p>
                            </Grid>
                            
                            <Grid
                                xs={6}
                                className="text-left"
                            >
                                <p className="mb-2">Exit Fee Decay Time</p>
                            </Grid>
                            <Grid
                                xs={6}
                                className="text-right"
                            >
                                <p className="mb-2">6 days</p>
                            </Grid>
                        </Grid>                            
                    </Grid> */}
                </Grid>
            </Grid>
        </Box>
    );
}

export default Together;